// Report Type Mapping Configuration
// This configuration maps report types to their respective output components

import EquifaxOutputComponent from '../components/reports/output/EquifaxOutputComponent';
import ExperianOutputComponent from '../components/reports/output/ExperianOutputComponent';
import BankStatementOutputComponent from '../components/reports/output/BankStatementOutputComponent';
import PANDetailsOutputComponent from '../components/reports/output/PANDetailsOutputComponent';
import EmploymentHistoryOutputComponent from '../components/reports/output/EmploymentHistoryOutputComponent';
import EHFUANOutputComponent from '../components/reports/output/EHFUANOutputComponent';
import DrivingLicenceOutputComponent from '../components/reports/output/DrivingLicenceOutputComponent';
import DrivingLicenceV2OutputComponent from '../components/reports/output/DrivingLicenceV2OutputComponent';
import VoterIdOutputComponent from '../components/reports/output/VoterIdOutputComponent';
import VoterID2OutputComponent from '../components/reports/output/VoterID2OutputComponent';
import CAMembershipOutputComponent from '../components/reports/output/CAMembershipOutputComponent';
import MobileBureauLookupOutputComponent from '../components/reports/output/MobileBureauLookupOutputComponent';
import RCDetailsOutputComponent from '../components/reports/output/RCDetailsOutputComponent';
import PAN2OutputComponent from '../components/reports/output/PAN2OutputComponent';
import GenericSurepassOutputComponent from '../components/reports/output/GenericSurepassOutputComponent';
import TanVerifyOutputComponent from '../components/reports/output/TanVerifyOutputComponent';
import TanAdvancedOutputComponent from '../components/reports/output/TanAdvancedOutputComponent';
import TanTdsCheckOutputComponent from '../components/reports/output/TanTdsCheckOutputComponent';
import TanCompanySearchOutputComponent from '../components/reports/output/TanCompanySearchOutputComponent';
import TinVerificationOutputComponent from '../components/reports/output/TinVerificationOutputComponent';
import IrdaiVerificationOutputComponent from '../components/reports/output/IrdaiVerificationOutputComponent';
import DeathVerificationOutputComponent from '../components/reports/output/DeathVerificationOutputComponent';
import EmploymentEmailCheckOutputComponent from '../components/reports/output/EmploymentEmailCheckOutputComponent';
import GstinOutputComponent from '../components/reports/output/GstinOutputComponent';
import GstinByPanOutputComponent from '../components/reports/output/GstinByPanOutputComponent';
import CompanyDetailsOutputComponent from '../components/reports/output/CompanyDetailsOutputComponent';
import UdyogAadharOutputComponent from '../components/reports/output/UdyogAadharOutputComponent';
import CibilReportOutputComponent from '../components/reports/output/CibilReportOutputComponent';
import CibilReportPdfOutputComponent from '../components/reports/output/CibilReportPdfOutputComponent';
import PrefillReportOutputComponent from '../components/reports/output/PrefillReportOutputComponent';
import PrefillByMobileOutputComponent from '../components/reports/output/PrefillByMobileOutputComponent';
import FuelPriceOutputComponent from '../components/reports/output/FuelPriceOutputComponent';
import ImeiVerificationOutputComponent from '../components/reports/output/ImeiVerificationOutputComponent';
import DomainVerificationOutputComponent from '../components/reports/output/DomainVerificationOutputComponent';
import MobileAgeOutputComponent from '../components/reports/output/MobileAgeOutputComponent';
import ElectricityBillOutputComponent from '../components/reports/output/ElectricityBillOutputComponent';
import DigilockerInitializeOutputComponent from '../components/reports/output/DigilockerInitializeOutputComponent';
import DigilockerListDocumentsOutputComponent from '../components/reports/output/DigilockerListDocumentsOutputComponent';
import DigilockerStatusOutputComponent from '../components/reports/output/DigilockerStatusOutputComponent';
import DrugLicenseOutputComponent from '../components/reports/output/DrugLicenseOutputComponent';
import EcourtsOutputComponent from '../components/reports/output/EcourtsOutputComponent';
import FaceOutputComponent from '../components/reports/output/FaceOutputComponent';
import GSTINVerificationOutputComponent from '../components/reports/output/GSTINVerificationOutputComponent';
import GlibBankStatementOutputComponent from '../components/reports/output/GlibBankStatementOutputComponent';
import GlibGstReturnOutputComponent from '../components/reports/output/GlibGstReturnOutputComponent';
import GlibGstReturnFetchOutputComponent from '../components/reports/output/GlibGstReturnFetchOutputComponent';
import GlibItrFetchOutputComponent from '../components/reports/output/GlibItrFetchOutputComponent';
import GujaratLandVerificationOutputComponent from '../components/reports/output/GujaratLandVerificationOutputComponent';
import KarnatakaLandVerificationOutputComponent from '../components/reports/output/KarnatakaLandVerificationOutputComponent';
import MadhyaPradeshLandVerificationOutputComponent from '../components/reports/output/MadhyaPradeshLandVerificationOutputComponent';
import NurseDoctorOutputComponent from '../components/reports/output/NurseDoctorOutputComponent';

// Component mapping
export const reportComponentMap = {
    'BUREAU_REPORT': {
        component: EquifaxOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string
            let parsedData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedData = JSON.parse(reportDetails.report_json);
                } catch (e) {
                    console.error('Error parsing report_json for BUREAU_REPORT:', e);
                    parsedData = reportDetails.report_json;
                }
            }
            
            // Check for download URL in multiple possible locations (matching EquifaxOutputComponent logic)
            const downloadUrl = parsedData?.pdf_download_url ||    // Check parsed JSON first
                              parsedData?.pdf_url ||              // Check parsed JSON pdf_url
                              reportDetails?.pdf_url || 
                              reportDetails?.pdf_download_url || 
                              reportDetails?.download_link || 
                              reportDetails?.download_url ||
                              reportDetails?.data?.pdf_download_url ||
                              reportDetails?.data?.pdf_url ||
                              reportDetails?.data?.download_link ||
                              reportDetails?.report_json?.pdf_download_url ||
                              reportDetails?.report_json?.pdf_url ||
                              reportDetails?.report_json?.download_link ||
                              reportDetails?.report_json?.download_url ||
                              reportDetails?.api_response?.pdf_download_url ||
                              reportDetails?.api_response?.pdf_url ||
                              reportDetails?.api_response?.download_link ||
                              selectedReport?.download_url;
            
            return {
                reportData: parsedData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: downloadUrl,
                onDownloadPDF: downloadUrl ? () => {
                    // If it's a full URL with http/https, it's likely an API endpoint that returns PDF
                    if (downloadUrl.startsWith('http')) {
                        // Create a temporary link element to trigger download
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        link.download = `equifax_report_${new Date().getTime()}.pdf`;
                        link.target = '_blank';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else {
                        // For relative URLs, open in new tab
                        window.open(downloadUrl, '_blank');
                    }
                    return true;
                } : null
            };
        }
    },
    'Equifax': {
        component: EquifaxOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string
            let parsedData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedData = JSON.parse(reportDetails.report_json);
                } catch (e) {
                    console.error('Error parsing report_json for Equifax:', e);
                    parsedData = reportDetails.report_json;
                }
            }
            
            // Check for download URL in multiple possible locations (matching EquifaxOutputComponent logic)
            const downloadUrl = parsedData?.pdf_download_url ||    // Check parsed JSON first
                              parsedData?.pdf_url ||              // Check parsed JSON pdf_url
                              reportDetails?.pdf_url || 
                              reportDetails?.pdf_download_url || 
                              reportDetails?.download_link || 
                              reportDetails?.download_url ||
                              reportDetails?.data?.pdf_download_url ||
                              reportDetails?.data?.pdf_url ||
                              reportDetails?.data?.download_link ||
                              reportDetails?.report_json?.pdf_download_url ||
                              reportDetails?.report_json?.pdf_url ||
                              reportDetails?.report_json?.download_link ||
                              reportDetails?.report_json?.download_url ||
                              reportDetails?.api_response?.pdf_download_url ||
                              reportDetails?.api_response?.pdf_url ||
                              reportDetails?.api_response?.download_link ||
                              selectedReport?.download_url;
            
            return {
                reportData: parsedData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: downloadUrl,
                onDownloadPDF: downloadUrl ? () => {
                    // If it's a full URL with http/https, it's likely an API endpoint that returns PDF
                    if (downloadUrl.startsWith('http')) {
                        // Create a temporary link element to trigger download
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        link.download = `equifax_report_${new Date().getTime()}.pdf`;
                        link.target = '_blank';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else {
                        // For relative URLs, open in new tab
                        window.open(downloadUrl, '_blank');
                    }
                    return true;
                } : null
            };
        }
    },
    'Experian Report': {
        component: ExperianOutputComponent,
        props: (reportDetails, selectedReport) => {
            return {
                reportData: reportDetails.report_json || reportDetails.api_response || reportDetails,
                serviceDetails: reportDetails.service || null,
                pdfDownloadUrl: reportDetails.pdf_download_url || reportDetails.pdf_url || null,
                pdfPasswordHint: reportDetails.pdf_password_hint || null
            };
        }
    },
    'Experian': {
        component: ExperianOutputComponent,
        props: (reportDetails, selectedReport) => {
            return {
                reportData: reportDetails.report_json || reportDetails.api_response || reportDetails,
                serviceDetails: reportDetails.service || null,
                pdfDownloadUrl: reportDetails.pdf_download_url || reportDetails.pdf_url || null,
                pdfPasswordHint: reportDetails.pdf_password_hint || null
            };
        }
    },
    'EXPERIAN_REPORT': {
        component: ExperianOutputComponent,
        props: (reportDetails, selectedReport) => {
            return {
                reportData: reportDetails.report_json || reportDetails.api_response || reportDetails,
                serviceDetails: reportDetails.service || null,
                pdfDownloadUrl: reportDetails.pdf_download_url || reportDetails.pdf_url || null,
                pdfPasswordHint: reportDetails.pdf_password_hint || null
            };
        }
    },
    'EXPERIAN_BUREAU': {
        component: ExperianOutputComponent,
        props: (reportDetails, selectedReport) => ({
            reportData: reportDetails.report_json || reportDetails.api_response || reportDetails,
            excelDownloadUrl: reportDetails.excel_url || reportDetails.excel_download_url || null,
            pdfDownloadUrl: reportDetails.pdf_url || reportDetails.pdf_download_url || selectedReport?.download_url || null,
            pdfPasswordHint: reportDetails.pdf_password_hint || null
        })
    },
    'EXPERIAN_BUREAU_REPORT': {
        component: ExperianOutputComponent,
        props: (reportDetails, selectedReport) => {
            return {
                reportData: reportDetails.report_json || reportDetails.api_response || reportDetails,
                serviceDetails: reportDetails.service || null,
                pdfDownloadUrl: reportDetails.pdf_download_url || reportDetails.pdf_url || null,
                pdfPasswordHint: reportDetails.pdf_password_hint || null
            };
        }
    },
    'EXPERIAN_CREDIT_REPORT_BOOSTMONEY': {
        component: ExperianOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Debug logging
            console.log('EXPERIAN_CREDIT_REPORT_BOOSTMONEY Mapping:', {
                reportDetails,
                selectedReport,
                pdf_download_url: reportDetails.pdf_download_url,
                pdf_password_hint: reportDetails.pdf_password_hint
            });

            // For database stored reports, pass the report_json directly
            return {
                reportData: reportDetails.report_json || reportDetails.api_response || reportDetails,
                serviceDetails: reportDetails.service || null,
                pdfDownloadUrl: reportDetails.pdf_download_url || reportDetails.pdf_url || null,
                pdfPasswordHint: reportDetails.pdf_password_hint || null
            };
        }
    },
    'BANK_STATEMENT': {
        component: BankStatementOutputComponent,
        props: (reportDetails, selectedReport) => {
            const bankData = reportDetails.report_json || reportDetails.api_response || reportDetails;
            
            // Extract loan details from various possible locations
            const loanDetails = bankData?.loan_details || 
                               selectedReport?.loan_details ||
                               bankData?.metadata?.loan_details;
            
            return {
                analysisResults: bankData,
                loanDetails: loanDetails,
                reportData: bankData,
                // Add handler for Excel download
                onDownloadExcel: () => {
                    // Check multiple possible locations for Excel download URL
                    const downloadUrl = reportDetails.excel_url || 
                                      reportDetails.download_url || 
                                      reportDetails.data?.excel_url ||
                                      reportDetails.data?.download_url ||
                                      bankData?.excel_url ||
                                      bankData?.download_url ||
                                      bankData?.data?.excel_url ||
                                      bankData?.data?.download_url ||
                                      selectedReport?.download_url ||
                                      selectedReport?.excel_url ||
                                      reportDetails.download_links?.url ||
                                      reportDetails.excel_links?.[Object.keys(reportDetails.excel_links || {})[0]];
                    
                    if (downloadUrl) {
                        // If it's a CSV or Excel file, trigger proper download
                        if (downloadUrl.includes('.csv') || downloadUrl.includes('.xlsx') || downloadUrl.includes('.xls')) {
                            const link = document.createElement('a');
                            link.href = downloadUrl;
                            link.download = `bank_statement_analysis_${new Date().getTime()}.csv`;
                            link.target = '_blank';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        } else {
                            window.open(downloadUrl, '_blank');
                        }
                        return true;
                    }
                    return false;
                },
                // Add handler for PDF download if URL exists
                onDownloadPDF: reportDetails.pdf_url || bankData?.pdf_url ? () => {
                    const pdfUrl = reportDetails.pdf_url || bankData?.pdf_url;
                    if (pdfUrl) {
                        window.open(pdfUrl, '_blank');
                        return true;
                    }
                    return false;
                } : null,
                pdfDownloadUrl: reportDetails.pdf_url || bankData?.pdf_url || null
            };
        }
    },
    'Bank Statement Analysis': {
        component: BankStatementOutputComponent,
        props: (reportDetails, selectedReport) => {
            const bankData = reportDetails.report_json || reportDetails.api_response || reportDetails;
            
            // Extract loan details from various possible locations
            let loanDetails = null;
            
            // First try to get from lead data
            if (reportDetails.lead) {
                loanDetails = {
                    loan_amount: reportDetails.lead.loan_amount || reportDetails.lead.loanAmount,
                    interest_rate: reportDetails.lead.rate || reportDetails.lead.interest_rate || reportDetails.lead.interestRate,
                    period: reportDetails.lead.period || reportDetails.lead.tenure,
                    emi: reportDetails.lead.emi || reportDetails.lead.monthlyEmi
                };
            }
            
            // If not found in lead, check in the bankData itself (might be stored with the report)
            if (!loanDetails || !loanDetails.loan_amount) {
                const storedLoanDetails = bankData.loanDetails || bankData.loan_details || 
                                        bankData.data?.loanDetails || bankData.data?.loan_details;
                if (storedLoanDetails) {
                    loanDetails = {
                        loan_amount: storedLoanDetails.loan_amount || storedLoanDetails.loanAmount,
                        interest_rate: storedLoanDetails.interest_rate || storedLoanDetails.interestRate || storedLoanDetails.rate,
                        period: storedLoanDetails.period || storedLoanDetails.tenure,
                        emi: storedLoanDetails.emi || storedLoanDetails.monthlyEmi
                    };
                }
            }
            
            // If still not found, check in metadata or request_data
            if (!loanDetails || !loanDetails.loan_amount) {
                const metadata = reportDetails.metadata || reportDetails.request_data;
                if (metadata) {
                    loanDetails = {
                        loan_amount: metadata.loan_amount || metadata.loanAmount,
                        interest_rate: metadata.interest_rate || metadata.interestRate || metadata.rate,
                        period: metadata.period || metadata.tenure,
                        emi: metadata.emi || metadata.monthlyEmi
                    };
                }
            }
            
            // Calculate EMI if not present but other values are available
            if (loanDetails && loanDetails.loan_amount && loanDetails.interest_rate && loanDetails.period && !loanDetails.emi) {
                const P = parseFloat(loanDetails.loan_amount);
                const r = parseFloat(loanDetails.interest_rate) / 100 / 12; // Monthly interest rate
                const n = parseInt(loanDetails.period);
                
                if (r > 0) {
                    loanDetails.emi = (P * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
                } else {
                    loanDetails.emi = P / n; // If interest rate is 0
                }
            }
            
            // Parse report_json if it's a string to extract excel_url
            let parsedReportJson = bankData;
            if (typeof bankData === 'string') {
                try {
                    parsedReportJson = JSON.parse(bankData);
                } catch (e) {
                    console.error('Failed to parse bankData:', e);
                }
            }

            // Extract excel_url from various possible locations
            const excelUrl = reportDetails.excel_download_url ||
                           reportDetails.excel_url ||
                           parsedReportJson?.excel_download_url ||
                           parsedReportJson?.excel_url ||
                           parsedReportJson?.data?.excel_download_url ||
                           parsedReportJson?.data?.excel_url;

            console.log('Bank Statement Mapping - Excel URL extracted:', excelUrl);
            console.log('Bank Statement Mapping - reportDetails keys:', Object.keys(reportDetails));

            return {
                analysisResults: parsedReportJson.data || parsedReportJson,
                reportData: {
                    ...reportDetails,
                    excel_download_url: excelUrl, // Ensure excel_url is at root level
                    excel_url: excelUrl
                }, // Pass full reportDetails to include root-level excel URLs
                loanDetails: loanDetails,
                serviceDetails: reportDetails.service || null,
                onDownloadExcel: () => {
                    // Check multiple possible locations for Excel download URL - prioritize root level
                    const downloadUrl = reportDetails.excel_download_url ||     // Root level (direct fetch)
                                      reportDetails.excel_url ||               // Alternative root level
                                      reportDetails.download_url || 
                                      reportDetails.data?.excel_download_url ||
                                      reportDetails.data?.excel_url ||
                                      reportDetails.data?.download_url ||
                                      bankData?.excel_download_url ||
                                      bankData?.excel_url ||
                                      bankData?.download_url ||
                                      bankData?.data?.excel_url ||
                                      bankData?.data?.download_url ||
                                      selectedReport?.download_url ||
                                      selectedReport?.excel_url ||
                                      reportDetails.download_links?.url ||
                                      reportDetails.excel_links?.[Object.keys(reportDetails.excel_links || {})[0]];
                    
                    if (downloadUrl) {
                        // If it's a CSV or Excel file, trigger proper download
                        if (downloadUrl.includes('.csv') || downloadUrl.includes('.xlsx') || downloadUrl.includes('.xls')) {
                            const link = document.createElement('a');
                            link.href = downloadUrl;
                            link.download = `bank_statement_analysis_${new Date().getTime()}.csv`;
                            link.target = '_blank';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        } else {
                            window.open(downloadUrl, '_blank');
                        }
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'PAN Details': {
        component: PANDetailsOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in PAN Details mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }
            
            return {
                reportData: parsedReportData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_download_url || reportDetails?.api_response?.pdf_download_url,
                onDownloadPDF: () => {
                    const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_download_url || reportDetails?.api_response?.pdf_download_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'Employment History by Mobile': {
        component: EmploymentHistoryOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string to access pdf_download_url at root
            let parsedData = reportDetails.report_json;
            if (typeof parsedData === 'string') {
                try {
                    parsedData = JSON.parse(parsedData);
                } catch (e) {
                    parsedData = reportDetails.report_json;
                }
            }

            // IMPORTANT: Prioritize reportDetails.pdf_url first as it contains the fresh token from backend
            // LeadController generates fresh tokens on every page load at line 598
            return {
                reportData: parsedData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: reportDetails.pdf_url || reportDetails.pdf_download_url || parsedData?.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_download_url || reportDetails?.api_response?.pdf_download_url,
                onDownloadPDF: () => {
                    const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || parsedData?.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_download_url || reportDetails?.api_response?.pdf_download_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'employment-history-from-mobile-comprehensive': {
        component: EmploymentHistoryOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string to access pdf_download_url at root
            let parsedData = reportDetails.report_json;
            if (typeof parsedData === 'string') {
                try {
                    parsedData = JSON.parse(parsedData);
                } catch (e) {
                    parsedData = reportDetails.report_json;
                }
            }

            // IMPORTANT: Prioritize reportDetails.pdf_url first as it contains the fresh token from backend
            return {
                reportData: parsedData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: reportDetails.pdf_url || reportDetails.pdf_download_url || parsedData?.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_download_url || reportDetails?.api_response?.pdf_download_url,
                onDownloadPDF: () => {
                    const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || parsedData?.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_download_url || reportDetails?.api_response?.pdf_download_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'Employment History by UAN': {
        component: EHFUANOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string to access pdf_download_url at root
            let parsedData = reportDetails.report_json;
            if (typeof parsedData === 'string') {
                try {
                    parsedData = JSON.parse(parsedData);
                } catch (e) {
                    parsedData = reportDetails.report_json;
                }
            }

            // IMPORTANT: Prioritize reportDetails.pdf_url first as it contains the fresh token from backend
            // LeadController generates fresh tokens on every page load at line 598
            return {
                reportData: parsedData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: reportDetails.pdf_url || reportDetails.pdf_download_url || parsedData?.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_download_url || reportDetails?.api_response?.pdf_download_url,
                onDownloadPDF: () => {
                    const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || parsedData?.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_download_url || reportDetails?.api_response?.pdf_download_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'uan-employment-history': {
        component: EHFUANOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string to access pdf_download_url at root
            let parsedData = reportDetails.report_json;
            if (typeof parsedData === 'string') {
                try {
                    parsedData = JSON.parse(parsedData);
                } catch (e) {
                    parsedData = reportDetails.report_json;
                }
            }

            // IMPORTANT: Prioritize reportDetails.pdf_url first as it contains the fresh token from backend
            return {
                reportData: parsedData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: reportDetails.pdf_url || reportDetails.pdf_download_url || parsedData?.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_download_url || reportDetails?.api_response?.pdf_download_url,
                onDownloadPDF: () => {
                    const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || parsedData?.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_download_url || reportDetails?.api_response?.pdf_download_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'UAN': {
        component: PANDetailsOutputComponent,
        props: (reportDetails, selectedReport) => ({
            reportData: reportDetails.report_json || reportDetails.api_response || reportDetails,
            pdfDownloadUrl: reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_download_url || reportDetails?.api_response?.pdf_download_url,
            onDownloadPDF: () => {
                const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_download_url || reportDetails?.api_response?.pdf_download_url;
                if (downloadUrl) {
                    window.open(downloadUrl, '_blank');
                    return true;
                }
                return false;
            }
        })
    },
    'uan-verification': {
        component: PANDetailsOutputComponent,
        props: (reportDetails, selectedReport) => ({
            reportData: reportDetails.report_json || reportDetails.api_response || reportDetails,
            pdfDownloadUrl: reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_download_url || reportDetails?.api_response?.pdf_download_url,
            onDownloadPDF: () => {
                const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_download_url || reportDetails?.api_response?.pdf_download_url;
                if (downloadUrl) {
                    window.open(downloadUrl, '_blank');
                    return true;
                }
                return false;
            }
        })
    },
    'Driving Licence': {
        component: DrivingLicenceOutputComponent,
        props: (reportDetails, selectedReport) => ({
            reportData: reportDetails.report_json || reportDetails.api_response || reportDetails,
            leadData: reportDetails.lead || null,
            serviceInfo: {
                provider: 'Tartan Data Services',
                service_type: 'Basic Driving Licence Verification',
                credits_required: 8
            },
            onDownloadPDF: () => {
                const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url;
                if (downloadUrl) {
                    window.open(downloadUrl, '_blank');
                    return true;
                }
                return false;
            }
        })
    },
    'driving-licence': {
        component: DrivingLicenceOutputComponent,
        props: (reportDetails, selectedReport) => ({
            reportData: reportDetails.report_json || reportDetails.api_response || reportDetails,
            leadData: reportDetails.lead || null,
            onDownloadPDF: () => {
                const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url;
                if (downloadUrl) {
                    window.open(downloadUrl, '_blank');
                    return true;
                }
                return false;
            }
        })
    },
    'driving-licence-detailed': {
        component: DrivingLicenceOutputComponent,
        props: (reportDetails, selectedReport) => ({
            reportData: reportDetails.report_json || reportDetails.api_response || reportDetails,
            leadData: reportDetails.lead || null,
            onDownloadPDF: () => {
                const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url;
                if (downloadUrl) {
                    window.open(downloadUrl, '_blank');
                    return true;
                }
                return false;
            }
        })
    },
    'VOTER_ID_DETAILS_GRIDLINES': {
        component: VoterID2OutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in VOTER_ID_DETAILS_GRIDLINES mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }

            // Extract voter details from the parsed data - GridLines V2 format
            const voterDetails = parsedReportData?.data?.data?.voter_data ||     // GridLines V2: data.data.voter_data
                               parsedReportData?.data?.voter_data ||             // Alternative: data.voter_data  
                               parsedReportData?.voter_data ||                   // Direct: voter_data
                               parsedReportData?.data?.voter_details ||          // Legacy: data.voter_details
                               parsedReportData?.voter_details ||                // Legacy: voter_details
                               parsedReportData?.data?.data ||                   // Sometimes nested as data.data
                               parsedReportData?.data ||                         // Fallback: data
                               parsedReportData;                                 // Last resort: entire data
            
            return {
                voterData: voterDetails,
                formData: {
                    voter_id: voterDetails?.document_id || reportDetails.reference || '',
                    phone: reportDetails.lead?.phone || '',
                    pan: reportDetails.lead?.pan || ''
                },
                serviceDetails: reportDetails.service || null,
                reportData: parsedReportData
            };
        }
    },
    'VOTER_ID_DETAILS': {
        component: VoterID2OutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in VOTER_ID_DETAILS mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }

            // Extract voter details from the parsed data - GridLines V2 format
            const voterDetails = parsedReportData?.data?.data?.voter_data ||     // GridLines V2: data.data.voter_data
                               parsedReportData?.data?.voter_data ||             // Alternative: data.voter_data  
                               parsedReportData?.voter_data ||                   // Direct: voter_data
                               parsedReportData?.data?.voter_details ||          // Legacy: data.voter_details
                               parsedReportData?.voter_details ||                // Legacy: voter_details
                               parsedReportData?.data?.data ||                   // Sometimes nested as data.data
                               parsedReportData?.data ||                         // Fallback: data
                               parsedReportData;                                 // Last resort: entire data

            return {
                voterData: voterDetails,
                formData: {
                    voter_id: voterDetails?.document_id || reportDetails.reference || '',
                    phone: reportDetails.lead?.phone || '',
                    pan: reportDetails.lead?.pan || ''
                },
                serviceDetails: reportDetails.service || null,
                reportData: parsedReportData
            };
        }
    },
    'voter-id-details-v2': {
        component: VoterID2OutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in voter-id-details-v2 mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }

            // Extract voter details from the parsed data - GridLines V2 format
            const voterDetails = parsedReportData?.data?.data?.voter_data ||     // GridLines V2: data.data.voter_data
                               parsedReportData?.data?.voter_data ||             // Alternative: data.voter_data  
                               parsedReportData?.voter_data ||                   // Direct: voter_data
                               parsedReportData?.data?.voter_details ||          // Legacy: data.voter_details
                               parsedReportData?.voter_details ||                // Legacy: voter_details
                               parsedReportData?.data?.data ||                   // Sometimes nested as data.data
                               parsedReportData?.data ||                         // Fallback: data
                               parsedReportData;                                 // Last resort: entire data

            return {
                voterData: parsedReportData,  // Pass full data to component
                formData: {
                    voter_id: voterDetails?.document_id || reportDetails.reference || '',
                    phone: reportDetails.lead?.phone || '',
                    pan: reportDetails.lead?.pan || ''
                },
                serviceDetails: reportDetails.service || null,
                reportData: parsedReportData
            };
        }
    },
    'PAN_DETAILS': {
        component: PAN2OutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in PAN_DETAILS mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }

            // Extract PAN details from the parsed data
            const panDetails = parsedReportData?.data?.pan_details || 
                             parsedReportData?.pan_details ||
                             parsedReportData;

            return {
                panData: panDetails,
                formData: {
                    pan: reportDetails.reference || '',
                    phone: reportDetails.lead?.phone || '',
                    name: reportDetails.lead?.name || ''
                },
                serviceDetails: reportDetails.service || null,
                reportData: parsedReportData
            };
        }
    },
    'PAN_DETAILS_GRIDLINES': {
        component: PAN2OutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in PAN_DETAILS_GRIDLINES mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }

            // Extract PAN details from the parsed data
            const panDetails = parsedReportData?.data?.pan_details || 
                             parsedReportData?.pan_details ||
                             parsedReportData;

            return {
                panData: panDetails,
                formData: {
                    pan: reportDetails.reference || '',
                    phone: reportDetails.lead?.phone || '',
                    name: reportDetails.lead?.name || ''
                },
                serviceDetails: reportDetails.service || null,
                reportData: parsedReportData
            };
        }
    },
    'PAN v1': {
        component: PANDetailsOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in PAN v1 mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }
            
            return {
                reportData: parsedReportData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: parsedReportData?.pdf_download_url || reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_download_url || reportDetails?.api_response?.pdf_download_url,
                onDownloadPDF: () => {
                    const downloadUrl = parsedReportData?.pdf_download_url || reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_download_url || reportDetails?.api_response?.pdf_download_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'PAN v2': {
        component: PAN2OutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in PAN v2 mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }

            // Extract PAN details from the parsed data
            const panDetails = parsedReportData?.data?.pan_details || 
                             parsedReportData?.pan_details ||
                             parsedReportData;

            return {
                panData: panDetails,
                formData: {
                    pan: reportDetails.reference || '',
                    phone: reportDetails.lead?.phone || '',
                    name: reportDetails.lead?.name || ''
                },
                serviceDetails: reportDetails.service || null,
                reportData: parsedReportData
            };
        }
    },
    'pan-details-v2': {
        component: PAN2OutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in pan-details-v2 mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }

            // Extract PAN details from the parsed data
            const panDetails = parsedReportData?.data?.pan_details || 
                             parsedReportData?.pan_details ||
                             parsedReportData;

            return {
                panData: panDetails,
                formData: {
                    pan: reportDetails.reference || '',
                    phone: reportDetails.lead?.phone || '',
                    name: reportDetails.lead?.name || ''
                },
                serviceDetails: reportDetails.service || null,
                reportData: parsedReportData
            };
        }
    },
    'DL_DETAILS_GRIDLINES': {
        component: DrivingLicenceV2OutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in DL_DETAILS_GRIDLINES mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }

            // Extract driving license details from the parsed data - GridLines V2 format
            const dlDetails = parsedReportData?.data?.data?.driving_license_data ||   // GridLines V2: data.data.driving_license_data
                             parsedReportData?.data?.driving_license_data ||         // Alternative: data.driving_license_data
                             parsedReportData?.driving_license_data ||               // Direct: driving_license_data
                             parsedReportData?.data?.dl_details ||                   // Legacy: data.dl_details
                             parsedReportData?.dl_details ||                         // Legacy: dl_details
                             parsedReportData?.data?.data ||                         // Sometimes nested as data.data
                             parsedReportData?.data ||                               // Fallback: data
                             parsedReportData;                                       // Last resort: entire data

            console.log('Driving Licence v2 - Extracted DL details:', dlDetails);

            return {
                reportData: parsedReportData,  // Pass full data to component
                leadData: reportDetails.lead || null,
                serviceInfo: {
                    provider: 'GridLines Technology',
                    service_type: 'Advanced Driving Licence Verification V2',
                    credits_required: 30
                },
                onDownloadPDF: () => {
                    const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'Driving Licence v2': {
        component: DrivingLicenceV2OutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in Driving Licence v2 mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }

            console.log('Driving Licence v2 - Parsed data structure:', parsedReportData);

            return {
                reportData: parsedReportData,  // Pass full data to component
                leadData: reportDetails.lead || null,
                serviceInfo: {
                    provider: 'GridLines Technology',
                    service_type: 'Advanced Driving Licence Verification V2',
                    credits_required: 30
                },
                onDownloadPDF: () => {
                    const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_download_url || reportDetails?.api_response?.pdf_download_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'Driving Licence V2': {
        component: DrivingLicenceV2OutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in Driving Licence V2 mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }

            // Extract driving license details from the parsed data - GridLines V2 format
            const dlDetails = parsedReportData?.data?.data?.driving_license_data ||   // GridLines V2: data.data.driving_license_data
                             parsedReportData?.data?.driving_license_data ||         // Alternative: data.driving_license_data
                             parsedReportData?.driving_license_data ||               // Direct: driving_license_data
                             parsedReportData?.data?.dl_details ||                   // Legacy: data.dl_details
                             parsedReportData?.dl_details ||                         // Legacy: dl_details
                             parsedReportData?.data?.data ||                         // Sometimes nested as data.data
                             parsedReportData?.data ||                               // Fallback: data
                             parsedReportData;                                       // Last resort: entire data

            return {
                reportData: dlDetails,
                leadData: reportDetails.lead || null,
                serviceInfo: {
                    provider: 'GridLines Technology',
                    service_type: 'Advanced Driving Licence Verification V2',
                    credits_required: 30
                },
                onDownloadPDF: () => {
                    const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'DRIVING_LICENCE_V2': {
        component: DrivingLicenceV2OutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in DRIVING_LICENCE_V2 mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }

            // Extract driving license details from the parsed data - GridLines V2 format
            const dlDetails = parsedReportData?.data?.data?.driving_license_data ||   // GridLines V2: data.data.driving_license_data
                             parsedReportData?.data?.driving_license_data ||         // Alternative: data.driving_license_data
                             parsedReportData?.driving_license_data ||               // Direct: driving_license_data
                             parsedReportData?.data?.dl_details ||                   // Legacy: data.dl_details
                             parsedReportData?.dl_details ||                         // Legacy: dl_details
                             parsedReportData?.data?.data ||                         // Sometimes nested as data.data
                             parsedReportData?.data ||                               // Fallback: data
                             parsedReportData;                                       // Last resort: entire data

            return {
                reportData: dlDetails,
                leadData: reportDetails.lead || null,
                onDownloadPDF: () => {
                    const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'driving-licence-v2': {
        component: DrivingLicenceV2OutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in driving-licence-v2 mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }

            // Extract driving license details from the parsed data - GridLines V2 format
            const dlDetails = parsedReportData?.data?.data?.driving_license_data ||   // GridLines V2: data.data.driving_license_data
                             parsedReportData?.data?.driving_license_data ||         // Alternative: data.driving_license_data
                             parsedReportData?.driving_license_data ||               // Direct: driving_license_data
                             parsedReportData?.data?.dl_details ||                   // Legacy: data.dl_details
                             parsedReportData?.dl_details ||                         // Legacy: dl_details
                             parsedReportData?.data?.data ||                         // Sometimes nested as data.data
                             parsedReportData?.data ||                               // Fallback: data
                             parsedReportData;                                       // Last resort: entire data

            return {
                reportData: dlDetails,
                leadData: reportDetails.lead || null,
                onDownloadPDF: () => {
                    const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'dl_details': {
        component: DrivingLicenceV2OutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in dl_details mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }

            console.log('dl_details - Parsed data structure:', parsedReportData);

            return {
                reportData: parsedReportData,  // Pass full data to component
                leadData: reportDetails.lead || null,
                serviceInfo: {
                    provider: 'GridLines Technology',
                    service_type: 'Advanced Driving Licence Verification V2',
                    credits_required: 30
                },
                onDownloadPDF: () => {
                    const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_download_url || reportDetails?.api_response?.pdf_download_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'DL_DETAILS': {
        component: DrivingLicenceV2OutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in DL_DETAILS mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }

            // Extract driving license details from the parsed data - GridLines V2 format
            const dlDetails = parsedReportData?.data?.data?.driving_license_data ||   // GridLines V2: data.data.driving_license_data
                             parsedReportData?.data?.driving_license_data ||         // Alternative: data.driving_license_data
                             parsedReportData?.driving_license_data ||               // Direct: driving_license_data
                             parsedReportData?.data?.dl_details ||                   // Legacy: data.dl_details
                             parsedReportData?.dl_details ||                         // Legacy: dl_details
                             parsedReportData?.data?.data ||                         // Sometimes nested as data.data
                             parsedReportData?.data ||                               // Fallback: data
                             parsedReportData;                                       // Last resort: entire data

            return {
                reportData: dlDetails,
                leadData: reportDetails.lead || null,
                onDownloadPDF: () => {
                    const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'Voter ID': {
        component: VoterIdOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in Voter ID mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }
            
            return {
                reportData: parsedReportData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: parsedReportData?.pdf_download_url ||      // Check parsed JSON first
                               parsedReportData?.pdf_url ||               // Check parsed JSON pdf_url
                               reportDetails.pdf_url || 
                               reportDetails.pdf_download_url || 
                               reportDetails.download_url || 
                               selectedReport?.download_url || 
                               reportDetails?.report_json?.pdf_url || 
                               reportDetails?.report_json?.pdf_download_url ||
                               reportDetails?.api_response?.pdf_url ||
                               reportDetails?.api_response?.pdf_download_url,
                serviceDetails: reportDetails.service || null,
                onDownloadPDF: () => {
                    const downloadUrl = parsedReportData?.pdf_download_url ||      // Check parsed JSON first
                                       parsedReportData?.pdf_url ||               // Check parsed JSON pdf_url
                                       reportDetails.pdf_url || 
                                       reportDetails.pdf_download_url || 
                                       reportDetails.download_url || 
                                       selectedReport?.download_url || 
                                       reportDetails?.report_json?.pdf_url || 
                                       reportDetails?.report_json?.pdf_download_url ||
                                       reportDetails?.api_response?.pdf_url ||
                                       reportDetails?.api_response?.pdf_download_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'voter-id': {
        component: VoterIdOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in voter-id mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }
            
            return {
                reportData: parsedReportData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: parsedReportData?.pdf_download_url ||      // Check parsed JSON first
                               parsedReportData?.pdf_url ||               // Check parsed JSON pdf_url
                               reportDetails.pdf_url || 
                               reportDetails.pdf_download_url || 
                               reportDetails.download_url || 
                               selectedReport?.download_url || 
                               reportDetails?.report_json?.pdf_url || 
                               reportDetails?.report_json?.pdf_download_url ||
                               reportDetails?.api_response?.pdf_url ||
                               reportDetails?.api_response?.pdf_download_url,
                serviceDetails: reportDetails.service || null,
                onDownloadPDF: () => {
                    const downloadUrl = parsedReportData?.pdf_download_url ||      // Check parsed JSON first
                                       parsedReportData?.pdf_url ||               // Check parsed JSON pdf_url
                                       reportDetails.pdf_url || 
                                       reportDetails.pdf_download_url || 
                                       reportDetails.download_url || 
                                       selectedReport?.download_url || 
                                       reportDetails?.report_json?.pdf_url || 
                                       reportDetails?.report_json?.pdf_download_url ||
                                       reportDetails?.api_response?.pdf_url ||
                                       reportDetails?.api_response?.pdf_download_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'voter-id-validation': {
        component: VoterIdOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in voter-id-validation mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }
            
            return {
                reportData: parsedReportData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: parsedReportData?.pdf_download_url ||      // Check parsed JSON first
                               parsedReportData?.pdf_url ||               // Check parsed JSON pdf_url
                               reportDetails.pdf_url || 
                               reportDetails.pdf_download_url || 
                               reportDetails.download_url || 
                               selectedReport?.download_url || 
                               reportDetails?.report_json?.pdf_url || 
                               reportDetails?.report_json?.pdf_download_url ||
                               reportDetails?.api_response?.pdf_url ||
                               reportDetails?.api_response?.pdf_download_url,
                serviceDetails: reportDetails.service || null,
                onDownloadPDF: () => {
                    const downloadUrl = parsedReportData?.pdf_download_url ||      // Check parsed JSON first
                                       parsedReportData?.pdf_url ||               // Check parsed JSON pdf_url
                                       reportDetails.pdf_url || 
                                       reportDetails.pdf_download_url || 
                                       reportDetails.download_url || 
                                       selectedReport?.download_url || 
                                       reportDetails?.report_json?.pdf_url || 
                                       reportDetails?.report_json?.pdf_download_url ||
                                       reportDetails?.api_response?.pdf_url ||
                                       reportDetails?.api_response?.pdf_download_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'CA Membership': {
        component: CAMembershipOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in CA Membership mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }
            
            return {
                reportData: parsedReportData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: reportDetails?.report_json?.data?.pdf_download_url || reportDetails?.report_json?.pdf_download_url || reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.api_response?.pdf_url,
                serviceDetails: reportDetails.service || null,
                onDownloadPDF: () => {
                    const downloadUrl = reportDetails?.report_json?.data?.pdf_download_url || reportDetails?.report_json?.pdf_download_url || reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.api_response?.pdf_url;
                    console.log('CA Membership onDownloadPDF - downloadUrl found:', downloadUrl);
                    if (downloadUrl) {
                        console.log('Opening CA membership PDF:', downloadUrl);
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    console.error('No download URL found for CA membership');
                    return false;
                }
            };
        }
    },
    'CA Membership Verification': {
        component: CAMembershipOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in CA Membership Verification mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }
            
            return {
                reportData: parsedReportData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url,
                serviceDetails: reportDetails.service || null,
                onDownloadPDF: () => {
                    const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'CA_MEMBERSHIP_VERIFICATION': {
        component: CAMembershipOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in CA_MEMBERSHIP_VERIFICATION mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }
            
            return {
                reportData: parsedReportData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url,
                serviceDetails: reportDetails.service || null,
                onDownloadPDF: () => {
                    const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'Mobile Number Lookup': {
        component: MobileBureauLookupOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in Mobile Number Lookup mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }
            
            return {
                reportData: parsedReportData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: parsedReportData?.pdf_download_url || parsedReportData?.pdf_url || reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url,
                serviceDetails: reportDetails.service || null,
                onDownloadPDF: () => {
                    const downloadUrl = parsedReportData?.pdf_download_url || parsedReportData?.pdf_url || reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url;
                    console.log('Mobile Number Lookup onDownloadPDF - downloadUrl found:', downloadUrl);
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'MOBILE_BUREAU_LOOKUP': {
        component: MobileBureauLookupOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in MOBILE_BUREAU_LOOKUP mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }
            
            return {
                reportData: parsedReportData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url,
                serviceDetails: reportDetails.service || null,
                onDownloadPDF: () => {
                    const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'Mobile Bureau Look up': {
        component: MobileBureauLookupOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in Mobile Bureau Look up mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }
            
            return {
                reportData: parsedReportData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url,
                serviceDetails: reportDetails.service || null,
                onDownloadPDF: () => {
                    const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'Mobile Bureau Lookup': {
        component: MobileBureauLookupOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in Mobile Bureau Lookup mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }

            return {
                reportData: parsedReportData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: parsedReportData?.pdf_download_url || parsedReportData?.pdf_url || reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url,
                serviceDetails: reportDetails.service || null,
                onDownloadPDF: () => {
                    const downloadUrl = parsedReportData?.pdf_download_url || parsedReportData?.pdf_url || reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url;
                    console.log('Mobile Bureau Lookup onDownloadPDF - downloadUrl found:', downloadUrl);
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'Mobile Bureau Look up': {
        component: MobileBureauLookupOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in Mobile Bureau Look up mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }

            return {
                reportData: parsedReportData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: parsedReportData?.pdf_download_url || parsedReportData?.pdf_url || reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url,
                serviceDetails: reportDetails.service || null,
                onDownloadPDF: () => {
                    const downloadUrl = parsedReportData?.pdf_download_url || parsedReportData?.pdf_url || reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url;
                    console.log('Mobile Bureau Look up onDownloadPDF - downloadUrl found:', downloadUrl);
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'Mobile Lookup': {
        component: MobileBureauLookupOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in Mobile Lookup mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }
            
            return {
                reportData: parsedReportData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url,
                serviceDetails: reportDetails.service || null,
                onDownloadPDF: () => {
                    const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'mobile bureau look up': {
        component: MobileBureauLookupOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in mobile bureau look up mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }
            
            return {
                reportData: parsedReportData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url,
                serviceDetails: reportDetails.service || null,
                onDownloadPDF: () => {
                    const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'mobile-bureau-lookup': {
        component: MobileBureauLookupOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in mobile-bureau-lookup mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }
            
            return {
                reportData: parsedReportData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url,
                serviceDetails: reportDetails.service || null,
                onDownloadPDF: () => {
                    const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    // 'remove Verification': {
    //     component: CAMembershipOutputComponent,
    //     props: (reportDetails, selectedReport) => {
    //         // Parse report_json if it's a string, otherwise use as-is
    //         let parsedReportData = reportDetails.report_json;
    //         if (typeof reportDetails.report_json === 'string') {
    //             try {
    //                 parsedReportData = JSON.parse(reportDetails.report_json);
    //             } catch (error) {
    //                 console.error('Error parsing report_json in remove mapping:', error);
    //                 parsedReportData = reportDetails.report_json;
    //             }
    //         }
            
    //         return {
    //             reportData: parsedReportData || reportDetails.api_response || reportDetails,
    //             pdfDownloadUrl: reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url,
    //             serviceDetails: reportDetails.service || null,
    //             onDownloadPDF: () => {
    //                 const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url;
    //                 if (downloadUrl) {
    //                     window.open(downloadUrl, '_blank');
    //                     return true;
    //                 }
    //                 return false;
    //             }
    //         };
    //     }
    // },
    // 'ca-membership': {
    //     component: CAMembershipOutputComponent,
    //     props: (reportDetails, selectedReport) => {
    //         // Parse report_json if it's a string, otherwise use as-is
    //         let parsedReportData = reportDetails.report_json;
    //         if (typeof reportDetails.report_json === 'string') {
    //             try {
    //                 parsedReportData = JSON.parse(reportDetails.report_json);
    //             } catch (error) {
    //                 console.error('Error parsing report_json in ca-membership mapping:', error);
    //                 parsedReportData = reportDetails.report_json;
    //             }
    //         }
            
    //         return {
    //             reportData: parsedReportData || reportDetails.api_response || reportDetails,
    //             pdfDownloadUrl: reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url,
    //             serviceDetails: reportDetails.service || null,
    //             onDownloadPDF: () => {
    //                 const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url;
    //                 if (downloadUrl) {
    //                     window.open(downloadUrl, '_blank');
    //                     return true;
    //                 }
    //                 return false;
    //             }
    //         };
    //     }
    // },
    // 'ca-membership-verification': {
    //     component: CAMembershipOutputComponent,
    //     props: (reportDetails, selectedReport) => {
    //         // Parse report_json if it's a string, otherwise use as-is
    //         let parsedReportData = reportDetails.report_json;
    //         if (typeof reportDetails.report_json === 'string') {
    //             try {
    //                 parsedReportData = JSON.parse(reportDetails.report_json);
    //             } catch (error) {
    //                 console.error('Error parsing report_json in ca-membership-verification mapping:', error);
    //                 parsedReportData = reportDetails.report_json;
    //             }
    //         }
            
    //         return {
    //             reportData: parsedReportData || reportDetails.api_response || reportDetails,
    //             pdfDownloadUrl: reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url,
    //             serviceDetails: reportDetails.service || null,
    //             onDownloadPDF: () => {
    //                 const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url;
    //                 if (downloadUrl) {
    //                     window.open(downloadUrl, '_blank');
    //                     return true;
    //                 }
    //                 return false;
    //             }
    //         };
    //     }
    // },
    // 'CA_MEMBERSHIP_VERIFICATION': {
    //     component: CAMembershipOutputComponent,
    //     props: (reportDetails, selectedReport) => {
    //         // Parse report_json if it's a string, otherwise use as-is
    //         let parsedReportData = reportDetails.report_json;
    //         if (typeof reportDetails.report_json === 'string') {
    //             try {
    //                 parsedReportData = JSON.parse(reportDetails.report_json);
    //             } catch (error) {
    //                 console.error('Error parsing report_json in CA_MEMBERSHIP_VERIFICATION mapping:', error);
    //                 parsedReportData = reportDetails.report_json;
    //             }
    //         }
            
    //         return {
    //             reportData: parsedReportData || reportDetails.api_response || reportDetails,
    //             pdfDownloadUrl: reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url,
    //             serviceDetails: reportDetails.service || null,
    //             onDownloadPDF: () => {
    //                 const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url || reportDetails?.report_json?.pdf_url || reportDetails?.api_response?.pdf_url;
    //                 if (downloadUrl) {
    //                     window.open(downloadUrl, '_blank');
    //                     return true;
    //                 }
    //                 return false;
    //             }
    //         };
    //     }
    // },
    'RC_DETAILS': {
        component: RCDetailsOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in RC_DETAILS mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }
            
            return {
                reportData: parsedReportData || reportDetails.api_response || reportDetails,
                serviceDetails: reportDetails.service || null
            };
        }
    },
    'RC_DETAILS': {
        component: RCDetailsOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in RC_DETAILS mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }
            
            return {
                reportData: parsedReportData || reportDetails.api_response || reportDetails,
                serviceDetails: reportDetails.service || null
            };
        }
    },
    'RC Details': {
        component: RCDetailsOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in RC Details mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }
            
            return {
                reportData: parsedReportData || reportDetails.api_response || reportDetails,
                serviceDetails: reportDetails.service || null
            };
        }
    },
    'Voter ID v1': {
        component: VoterIdOutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in Voter ID v1 mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }
            
            return {
                reportData: parsedReportData || reportDetails.api_response || reportDetails,
                pdfDownloadUrl: parsedReportData?.pdf_download_url ||
                               parsedReportData?.pdf_url ||
                               reportDetails.pdf_url || 
                               reportDetails.pdf_download_url || 
                               reportDetails.download_url || 
                               selectedReport?.download_url || 
                               reportDetails?.report_json?.pdf_url || 
                               reportDetails?.report_json?.pdf_download_url ||
                               reportDetails?.api_response?.pdf_url ||
                               reportDetails?.api_response?.pdf_download_url,
                serviceDetails: reportDetails.service || null,
                onDownloadPDF: () => {
                    const downloadUrl = parsedReportData?.pdf_download_url ||
                                       parsedReportData?.pdf_url ||
                                       reportDetails.pdf_url || 
                                       reportDetails.pdf_download_url || 
                                       reportDetails.download_url || 
                                       selectedReport?.download_url || 
                                       reportDetails?.report_json?.pdf_url || 
                                       reportDetails?.report_json?.pdf_download_url ||
                                       reportDetails?.api_response?.pdf_url ||
                                       reportDetails?.api_response?.pdf_download_url;
                    if (downloadUrl) {
                        window.open(downloadUrl, '_blank');
                        return true;
                    }
                    return false;
                }
            };
        }
    },
    'Voter ID v2': {
        component: VoterID2OutputComponent,
        props: (reportDetails, selectedReport) => {
            // Parse report_json if it's a string, otherwise use as-is
            let parsedReportData = reportDetails.report_json;
            if (typeof reportDetails.report_json === 'string') {
                try {
                    parsedReportData = JSON.parse(reportDetails.report_json);
                } catch (error) {
                    console.error('Error parsing report_json in Voter ID v2 mapping:', error);
                    parsedReportData = reportDetails.report_json;
                }
            }

            // Extract voter details from the parsed data - GridLines V2 format
            const voterDetails = parsedReportData?.data?.data?.voter_data ||     // GridLines V2: data.data.voter_data
                               parsedReportData?.data?.voter_data ||             // Alternative: data.voter_data  
                               parsedReportData?.voter_data ||                   // Direct: voter_data
                               parsedReportData?.data?.voter_details ||          // Legacy: data.voter_details
                               parsedReportData?.voter_details ||                // Legacy: voter_details
                               parsedReportData?.data?.data ||                   // Sometimes nested as data.data
                               parsedReportData?.data ||                         // Fallback: data
                               parsedReportData;                                 // Last resort: entire data

            // Pass the full parsed data to component so it can handle the extraction itself
            return {
                voterData: parsedReportData,  // Pass full data to component
                formData: {
                    voter_id: voterDetails?.document_id || reportDetails.reference || '',
                    phone: reportDetails.lead?.phone || '',
                    pan: reportDetails.lead?.pan || ''
                },
                serviceDetails: reportDetails.service || null,
                reportData: parsedReportData
            };
        }
    },
    'Driving Licence v1': {
        component: DrivingLicenceOutputComponent,
        props: (reportDetails, selectedReport) => ({
            reportData: reportDetails.report_json || reportDetails.api_response || reportDetails,
            leadData: reportDetails.lead || null,
            serviceInfo: {
                provider: 'Tartan Data Services',
                service_type: 'Basic Driving Licence Verification',
                credits_required: 8
            },
            onDownloadPDF: () => {
                const downloadUrl = reportDetails.pdf_url || reportDetails.pdf_download_url || reportDetails.download_url || selectedReport?.download_url;
                if (downloadUrl) {
                    window.open(downloadUrl, '_blank');
                    return true;
                }
                return false;
            }
        })
    },
    // ─── Surepass generic output (all new API types) ─────────────────────────────
    'TAN_VERIFY':                 { component: TanVerifyOutputComponent,          props: (r) => ({ reportData: r }) },
    'TAN_ADVANCED':               { component: TanAdvancedOutputComponent,        props: (r) => ({ reportData: r }) },
    'TAN_TDS_CHECK':              { component: TanTdsCheckOutputComponent,        props: (r) => ({ reportData: r }) },
    'TAN_COMPANY_SEARCH':         { component: TanCompanySearchOutputComponent,   props: (r) => ({ reportData: r }) },
    'TIN_VERIFICATION':           { component: TinVerificationOutputComponent,    props: (r) => ({ reportData: r }) },
    'IRDAI_VERIFICATION':         { component: IrdaiVerificationOutputComponent,  props: (r) => ({ reportData: r }) },
    'DEATH_VERIFICATION':         { component: DeathVerificationOutputComponent,  props: (r) => ({ reportData: r }) },
    'PREFILL_REPORT':             { component: PrefillReportOutputComponent,      props: (r) => ({ reportData: r }) },
    'PREFILL_BY_MOBILE':          { component: PrefillByMobileOutputComponent,    props: (r) => ({ reportData: r }) },
    'EMPLOYMENT_EMAIL_CHECK':     { component: EmploymentEmailCheckOutputComponent, props: (r) => ({ reportData: r }) },
    'SMS_SEND_OTP':               { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'SMS Send OTP',                 icon: 'pi-send'        }) },
    'SMS_SUBMIT_OTP':             { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'SMS Submit OTP',               icon: 'pi-check-circle'}) },
    'DIGILOCKER_LIST_DOCUMENTS':  { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Digilocker Documents',         icon: 'pi-folder-open' }) },
    'DIGILOCKER_DOWNLOAD_DOCUMENT':{ component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Digilocker Download',         icon: 'pi-download'    }) },
    'DIGILOCKER_INITIALIZE':      { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Digilocker Initialize',        icon: 'pi-folder'      }) },
    'DIGILOCKER_STATUS':          { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Digilocker Status',            icon: 'pi-info-circle' }) },
    // GLIB (Autosift) BSA — the stored report_json carries work_order_id, stage,
    // download_urls and the partial-coverage flags; the component unwraps both
    // the live /status shape and this stored shape.
    // Vendor-neutral names (current). The GLIB-prefixed keys below are legacy —
    // reports created before the rename still carry them, so both must resolve.
    'Bank Statement Analysis-V2': { component: GlibBankStatementOutputComponent, props: (r) => ({ reportData: r }) },
    'GLIB Bank Statement Analysis': { component: GlibBankStatementOutputComponent, props: (r) => ({ reportData: r }) },
    // GLIB GST — report_json carries the parsed GSTR-3B returns under `returns`.
    'GST Return Analysis': { component: GlibGstReturnOutputComponent, props: (r) => ({ reportData: r }) },
    // The consent flow returns a DIFFERENT payload from the upload flow — one
    // aggregated portal extract (gstr.details[]) rather than per-return tables —
    // so it needs its own output component.
    'GST Return Fetch': { component: GlibGstReturnFetchOutputComponent, props: (r) => ({ reportData: r }) },
    'ITR Fetch': { component: GlibItrFetchOutputComponent, props: (r) => ({ reportData: r }) },
    'GLIB GST Return Analysis': { component: GlibGstReturnOutputComponent, props: (r) => ({ reportData: r }) },
    'GSTIN_VERIFICATION_BASIC':   { component: GstinOutputComponent,             props: (r) => ({ reportData: r }) },
    'GSTIN_BY_PAN':               { component: GstinByPanOutputComponent,        props: (r) => ({ reportData: r }) },
    'COMPANY_DETAILS':            { component: CompanyDetailsOutputComponent,    props: (r) => ({ reportData: r }) },
    'RERA_V2':                    { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'RERA V2 Verification',         icon: 'pi-home'        }) },
    'MCA_CREATE_ORDER':           { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'MCA Create Order',             icon: 'pi-file-plus'   }) },
    'MCA_ORDER_LIST':             { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'MCA Order List',               icon: 'pi-list'        }) },
    'UDYOG_AADHAR':               { component: UdyogAadharOutputComponent,      props: (r) => ({ reportData: r }) },
    'UDYAM_OTP_SEND':             { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Udyam OTP Send',               icon: 'pi-send'        }) },
    'UDYAM_OTP_SUBMIT':           { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Udyam OTP Submit',             icon: 'pi-check-circle'}) },
    'CIBIL_REPORT':               { component: CibilReportOutputComponent,      props: (r) => ({ reportData: r }) },
    'CIBIL_REPORT_PDF':           { component: CibilReportPdfOutputComponent,   props: (r) => ({ reportData: r }) },
    'ITR_CREATE_CLIENT':          { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'ITR Create Client',            icon: 'pi-user-plus'   }) },
    'ITR_CHECK_CREDENTIALS':      { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'ITR Check Credentials',        icon: 'pi-check-circle'}) },
    'ITR_DOWNLOAD_PROFILE':       { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'ITR Download Profile',         icon: 'pi-user'        }) },
    'ITR_DOWNLOAD_ITR':           { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'ITR Download',                 icon: 'pi-file'        }) },
    'ITR_DOWNLOAD_26AS':          { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Form 26AS Download',           icon: 'pi-file-pdf'    }) },
    'ITR_DOWNLOAD_ITR_V':         { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'ITR-V Download',               icon: 'pi-file-pdf'    }) },
    'ITR_GET_PROFILE':            { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'ITR Get Profile',              icon: 'pi-user'        }) },
    'ITR_FORGET_PASSWORD':        { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'ITR Forget Password',          icon: 'pi-key'         }) },
    'ITR_SUBMIT_OTP':             { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'ITR Submit OTP',               icon: 'pi-lock-open'   }) },
    'ITR_DOWNLOAD_AIS_V2':        { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'ITR AIS V2 Download',          icon: 'pi-download'    }) },
    'ITR_GET_AIS':                { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'ITR Get AIS',                  icon: 'pi-eye'         }) },
    'ITR_GET_ITR_DETAILS':        { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'ITR Details',                  icon: 'pi-info-circle' }) },
    'ITR_GET_26AS_DETAILS':       { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: '26AS Details',                 icon: 'pi-info-circle' }) },
    'FACE_MATCH':                 { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Face Match',                   icon: 'pi-users'       }) },
    'FACE_LIVENESS':              { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Face Liveness',                icon: 'pi-camera'      }) },
    'FACE_LIVENESS_V3':           { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Face Liveness V3',             icon: 'pi-camera'      }) },
    'FACE_LIVENESS_V4':           { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Face Liveness V4',             icon: 'pi-camera'      }) },
    'FACE_BACKGROUND_REMOVER':    { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Face Background Remover',      icon: 'pi-image'       }) },
    'FACE_EXTRACT':               { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Face Extract',                 icon: 'pi-search'      }) },
    'ELECTRICITY_OPERATOR_LIST':  { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Electricity Operators',        icon: 'pi-bolt'        }) },
    'SE_STATE_LIST':              { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'SE State List',                icon: 'pi-map'         }) },
    'SE_DETAILS':                 { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'SE Details',                   icon: 'pi-info-circle' }) },
    'ESIGN_INITIALIZE':           { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Esign Initialize',             icon: 'pi-file-edit'   }) },
    'ESIGN_INITIALIZE_NSDL_STAMP':{ component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Esign NSDL Stamp',             icon: 'pi-file'        }) },
    'ESIGN_INITIALIZE_SURESIGN':  { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Esign Suresign',               icon: 'pi-file'        }) },
    'ESIGN_INITIALIZE_HSM':       { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Esign HSM',                    icon: 'pi-lock'        }) },
    'ESIGN_GET_UPLOAD_LINK':      { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Esign Upload Link',            icon: 'pi-upload'      }) },
    'ESIGN_SET_BRANDING':         { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Esign Branding',               icon: 'pi-palette'     }) },
    'ESIGN_UPLOAD_PDF_VIA_LINK':  { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Esign Upload PDF',             icon: 'pi-upload'      }) },
    'ESIGN_GET_SIGNED_DOCUMENT':  { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Signed Document',              icon: 'pi-file-check'  }) },
    'ESIGN_GET_AUDIT_TRAIL':      { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Audit Trail',                  icon: 'pi-history'     }) },
    'ESIGN_GET_STATUS':           { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Esign Status',                 icon: 'pi-info-circle' }) },
    'ESIGN_GET_REPORT':           { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Esign Report',                 icon: 'pi-chart-bar'   }) },
    'FUEL_PRICE_STATE_LIST':      { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'Fuel Price State List',        icon: 'pi-list'        }) },
    'FUEL_PRICE':                 { component: FuelPriceOutputComponent, props: (r) => ({ reportData: r }) },
    'IMEI_VERIFICATION':          { component: ImeiVerificationOutputComponent, props: (r) => ({ reportData: r }) },
    'DOMAIN_VERIFICATION':        { component: DomainVerificationOutputComponent, props: (r) => ({ reportData: r }) },
    'MOBILE_AGE':                 { component: MobileAgeOutputComponent, props: (r) => ({ reportData: r }) },
    'ELECTRICITY_BILL':           { component: ElectricityBillOutputComponent, props: (r) => ({ reportData: r }) },
    'MCA_GET_STATUS':             { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'MCA Status',                   icon: 'pi-info-circle' }) },
    'DRUG_LICENSE_VERIFICATION':  { component: DrugLicenseOutputComponent, props: (r) => ({ reportData: r }) },
    'ECOURTS_SEARCH':             { component: EcourtsOutputComponent, props: (r) => ({ reportData: r }) },
    'ECOURTS_CNR_SEARCH':         { component: EcourtsOutputComponent, props: (r) => ({ reportData: r }) },
    'ECOURTS_SEARCH_V2':          { component: EcourtsOutputComponent, props: (r) => ({ reportData: r }) },
    'FSSAI_VERIFICATION':         { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'FSSAI Verification',           icon: 'pi-apple'       }) },
    'FSSAI_V2_VERIFICATION':      { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'FSSAI V2',                     icon: 'pi-apple'       }) },
    'FSSAI_CERTIFICATE':          { component: GenericSurepassOutputComponent, props: (r) => ({ reportData: r, title: 'FSSAI Certificate',            icon: 'pi-file'        }) },
    'NURSE_VERIFICATION':         { component: NurseDoctorOutputComponent, props: (r) => ({ reportData: r, title: 'Nurse Verification Report', icon: 'pi-heart-fill' }) },
    'DOCTOR_VERIFICATION':        { component: NurseDoctorOutputComponent, props: (r) => ({ reportData: r, title: 'Doctor Verification Report', icon: 'pi-user' }) },
    'GUJARAT_LAND_VERIFICATION':  { component: GujaratLandVerificationOutputComponent, props: (r) => ({ reportData: r }) },
    'MADHYA_PRADESH_LAND_VERIFICATION': { component: MadhyaPradeshLandVerificationOutputComponent, props: (r) => ({ reportData: r }) },
    'KARNATAKA_LAND_VERIFICATION': { component: KarnatakaLandVerificationOutputComponent, props: (r) => ({ reportData: r }) },
    // Default component for unknown types
    'default': {
        component: null,
        props: () => ({})
    }
};

// Helper function to get component configuration
export const getReportComponent = (reportType) => {
    return reportComponentMap[reportType] || reportComponentMap['default'];
};

// Helper function to determine report type from data
export const determineReportType = (data) => {
    if (!data) return 'Unknown';

    // Exact report_name matches FIRST — prevents false positives from substring checks
    if (data.report_name) {
        if (data.report_name === 'GSTIN_VERIFICATION' || data.report_name === 'GST_VERIFICATION' || data.report_name === 'GSTIN') return 'GSTIN_VERIFICATION_BASIC';
        if (data.report_name === 'GSTIN_VERIFICATION_BASIC') return 'GSTIN_VERIFICATION_BASIC';
        if (data.report_name === 'GSTIN_ADVANCED' || data.report_name === 'GSTIN Advanced') return 'GSTIN Advanced';
        if (data.report_name === 'GSTIN_BY_PAN') return 'GSTIN_BY_PAN';
        if (data.report_name === 'CA_MEMBERSHIP_VERIFICATION' || data.report_name === 'CA_MEMBERSHIP') return 'CA Membership';
    }

    // CA Membership detection via data indicators (for legacy/Tartan responses without exact report_name)
    const caIndicators = {
        hasMembershipInput: data.status?.input?.membership_no ||
                           data.report_json?.status?.input?.membership_no ||
                           data.view_data?.status?.input?.membership_no,
        hasAssociateYear: data.response?.AssociateYear ||
                         data.report_json?.response?.AssociateYear ||
                         data.data?.response?.AssociateYear ||
                         data.view_data?.AssociateYear,
        hasQualification: data.response?.Qualification ||
                         data.report_json?.response?.Qualification ||
                         data.data?.response?.Qualification,
    };

    if (caIndicators.hasMembershipInput || caIndicators.hasAssociateYear ||
        caIndicators.hasQualification) {
        return 'CA Membership';
    }
    
    // Priority check: If report_name is RC_DETAILS, return immediately
    if (data.report_name === 'RC_DETAILS' || data.report_name === 'RC Details') {
        console.log('RC Details detected from report_name field');
        return 'RC Details';
    }

    // Priority check: Surepass type names — trust report_name directly
    const surepassTypes = [
        'TAN_VERIFY','TAN_ADVANCED','TAN_TDS_CHECK','TAN_COMPANY_SEARCH',
        'TIN_VERIFICATION','IRDAI_VERIFICATION','DEATH_VERIFICATION',
        'PREFILL_REPORT','PREFILL_BY_MOBILE','EMPLOYMENT_EMAIL_CHECK',
        'SMS_SEND_OTP','SMS_SUBMIT_OTP',
        'DIGILOCKER_LIST_DOCUMENTS','DIGILOCKER_DOWNLOAD_DOCUMENT',
        'DIGILOCKER_INITIALIZE','DIGILOCKER_STATUS',
        'GSTIN_VERIFICATION_BASIC','GSTIN_BY_PAN','COMPANY_DETAILS',
        'RERA_V2','MCA_CREATE_ORDER','MCA_ORDER_LIST',
        'UDYOG_AADHAR','UDYAM_OTP_SEND','UDYAM_OTP_SUBMIT',
        'CIBIL_REPORT','CIBIL_REPORT_PDF',
        'ITR_CREATE_CLIENT','ITR_CHECK_CREDENTIALS','ITR_DOWNLOAD_PROFILE',
        'ITR_DOWNLOAD_ITR','ITR_DOWNLOAD_26AS','ITR_DOWNLOAD_ITR_V',
        'ITR_GET_PROFILE','ITR_FORGET_PASSWORD','ITR_SUBMIT_OTP',
        'ITR_DOWNLOAD_AIS_V2','ITR_GET_AIS','ITR_GET_ITR_DETAILS','ITR_GET_26AS_DETAILS',
        'FACE_MATCH','FACE_LIVENESS','FACE_LIVENESS_V3','FACE_LIVENESS_V4',
        'FACE_BACKGROUND_REMOVER','FACE_EXTRACT',
        'ELECTRICITY_OPERATOR_LIST','SE_STATE_LIST','SE_DETAILS',
        'ESIGN_INITIALIZE','ESIGN_INITIALIZE_NSDL_STAMP','ESIGN_INITIALIZE_SURESIGN',
        'ESIGN_INITIALIZE_HSM','ESIGN_GET_UPLOAD_LINK','ESIGN_SET_BRANDING',
    ];
    if (data.report_name && surepassTypes.includes(data.report_name)) {
        return data.report_name;
    }

    // Priority check: trust stored report_name for all known types before heuristic detection
    const reportNameMap = {
        'Experian':                  'Experian',
        'EXPERIAN_REPORT':           'Experian',
        'EXPERIAN_BUREAU_REPORT':    'Experian',
        'EXPERIAN_BUREAU':           'Experian',
        'BANK_STATEMENT':            'BANK_STATEMENT',
        'Bank Statement Analysis':   'Bank Statement Analysis',
        'Bank Statement Analysis-V2': 'Bank Statement Analysis-V2',
        'GST Return Analysis': 'GST Return Analysis',
        'GST Return Fetch': 'GST Return Fetch',
        'ITR Fetch': 'ITR Fetch',
        // Legacy names from before the vendor-neutral rename.
        'GLIB Bank Statement Analysis': 'GLIB Bank Statement Analysis',
        'GLIB GST Return Analysis': 'GLIB GST Return Analysis',
        'BUREAU_REPORT':             'BUREAU_REPORT',
        'Equifax':                   'Equifax',
        'EQUIFAX':                   'Equifax',
        'PAN':                       'PAN',
        'GST':                       'GST',
        'ITR':                       'ITR',
        'GSTIN':                     'GSTIN',
        'Aadhaar':                   'Aadhaar',
        'CIBIL':                     'CIBIL',
        'DL':                        'DL',
        'Voter ID':                  'Voter ID',
    };
    if (data.report_name && reportNameMap[data.report_name]) {
        console.log('Report type determined from report_name:', data.report_name, '->', reportNameMap[data.report_name]);
        return reportNameMap[data.report_name];
    }

    // Check for Equifax structure - multiple possible patterns
    // Check for profile_data which is specific to Equifax reports
    if (data.profile_data ||
        data.data?.profile_data ||
        data.data?.data?.profile_data ||
        data.report_json?.profile_data ||
        data.report_json?.data?.profile_data ||
        data.api_response?.profile_data ||
        data.api_response?.data?.profile_data ||
        data.CCRResponse || 
        data.report_json?.CCRResponse ||
        data.data?.CCRResponse ||
        data.response?.CCRResponse ||
        data.api_response?.CCRResponse ||
        data.equifax_response ||
        data.data?.equifax_response ||
        data.report_json?.equifax_response ||
        (data.response && (data.response.accounts || data.response.accountDetails || data.response.score)) ||
        (data.data?.response && (data.data.response.accounts || data.data.response.accountDetails || data.data.response.score)) ||
        (data.report_json?.data?.response && (data.report_json.data.response.accounts || data.report_json.data.response.accountDetails || data.report_json.data.response.score)) ||
        data.creditScore ||
        data.data?.creditScore ||
        data.report_json?.creditScore ||
        data.bureau_report ||
        data.data?.bureau_report ||
        data.report_json?.bureau_report ||
        // Check for Equifax specific fields
        (data.score_detail) ||
        (data.account_summary) ||
        (data.account_detail) ||
        (data.data?.score_detail) ||
        (data.data?.account_summary) ||
        (data.data?.account_detail) ||
        (data.data?.data?.score_detail) ||
        (data.data?.data?.account_summary) ||
        (data.data?.data?.account_detail)) {
        console.log('Detected as Equifax report');
        return 'Equifax';
    }
    
    // Check for Experian (BoostMoney) structure - Check for EXPERIAN bureau name or specific fields
    if (data.bureauName === 'EXPERIAN' ||
        data.raw_data ||
        data.data?.raw_data ||
        data.report_json?.raw_data ||
        // Check for Experian specific structure with personalInformation (not personal_information)
        data.data?.personalInformation ||
        data.data?.reportSummary ||
        data.data?.creditAccountInformationDetails ||
        data.data?.data?.personalInformation ||
        data.data?.data?.reportSummary ||
        data.data?.data?.creditAccountInformationDetails ||
        data.raw_data?.data?.personalInformation ||
        data.raw_data?.data?.reportSummary ||
        // Check for analysis structure specific to Experian
        (data.analysis && data.analysis.creditHistory && data.analysis.enquiries) ||
        // BoostMoney specific fields
        (data.data && data.data.parsed_data) ||
        (data.report_json && data.report_json.parsed_data) ||
        data.business_user_id ||
        data.data?.business_user_id ||
        data.report_json?.business_user_id) {
        console.log('Detected as Experian report');
        return 'Experian';
    }
    
    // Check for Bank Statement structure - multiple possible patterns
    if (data.data?.account_summaries || 
        data.report_json?.data?.account_summaries ||
        data.account_summaries ||
        data.response?.account_summaries ||
        data.api_response?.account_summaries ||
        data.bankStatement ||
        data.data?.bankStatement ||
        data.report_json?.bankStatement ||
        data.bank_analysis ||
        data.data?.bank_analysis ||
        data.report_json?.bank_analysis ||
        data.statement_analysis ||
        data.data?.statement_analysis ||
        data.report_json?.statement_analysis ||
        data.transactions ||
        data.data?.transactions ||
        data.report_json?.transactions ||
        (data.response && (data.response.transactions || data.response.balance || data.response.statement)) ||
        (data.data?.response && (data.data.response.transactions || data.data.response.balance || data.data.response.statement)) ||
        (data.report_json?.data?.response && (data.report_json.data.response.transactions || data.report_json.data.response.balance || data.report_json.data.response.statement))) {
        return 'Bank Statement Analysis';
    }
    
    // Check for PAN structure - multiple possible locations
    if (data.response?.response?.pan || 
        data.report_json?.response?.response?.pan || 
        data.data?.response?.pan ||
        data.response?.pan ||
        data.pan_details ||
        data.report_json?.data?.response?.pan ||
        data.report_json?.response?.pan) {
        return 'PAN Details';
    }
    
    // Check for Employment History structure
    if (data.response?.employment_data || 
        data.report_json?.response?.employment_data || 
        data.employment_data ||
        data.report_json?.response?.response?.employment_data ||
        data.response?.response?.employment_data ||
        (data.report_json && typeof data.report_json === 'object' && 
         data.report_json.response && 
         data.report_json.response.response && 
         data.report_json.response.response.employment_data)) {
        
        // Check if it's UAN based employment history
        if (data.report_name === 'UAN_EMPLOYMENT_HISTORY' || 
            data.report_json?.employment_summary?.uan ||
            data.employment_summary?.uan ||
            (data.report_json?.response?.status?.input?.uan) ||
            (data.response?.status?.input?.uan)) {
            return 'Employment History by UAN';
        }
        
        return 'Employment History by Mobile';
    }
    
    // Check for UAN verification structure
    if (data.response?.uan_details || data.report_json?.response?.uan_details || data.uan_details) {
        return 'UAN';
    }
    
    // Check for Driving Licence V2 structure (check V2 first as it's more specific)
    // Check for V2 indicators:
    // 0. Check report_name first (most reliable)
    if (data.report_name === 'Driving Licence v2') {
        return 'Driving Licence v2';  // Return the correct key that exists in reportComponentMap
    }

    // 1. Status message contains "DL Verification Advanced (V2)"
    if (data.status?.statusMessage && data.status.statusMessage.includes('DL Verification Advanced (V2)')) {
        return 'Driving Licence v2';
    }

    // 2. Has GridLines V2 structure - YOUR EXACT STRUCTURE: data.data.driving_license_data
    if (data.data?.data?.driving_license_data) {
        return 'Driving Licence v2';
    }

    // 3. Alternative GridLines V2 structure (data.driving_license_data)
    if (data.data?.driving_license_data) {
        return 'Driving Licence v2';
    }

    // 4. Has nested DL details structure
    if (data.data?.dl_details?.raw_response?.data?.data?.driving_license_data ||
        data.driving_license_data ||
        (data.data?.dl_details?.raw_response && data.data?.dl_details?.raw_response?.data)) {
        return 'Driving Licence v2';
    }

    // 5. Response code indicates GridLines success and has specific V2 structure
    if (data.data?.code === '1000' && data.data?.driving_license_data) {
        return 'Driving Licence v2';
    }
    
    // Check for Driving Licence structure
    if (data.response?.holderDetails || data.report_json?.response?.holderDetails || 
        data.licence_details?.holderDetails || data.report_json?.licence_details?.holderDetails ||
        data.data?.licence_details?.holderDetails) {
        return 'Driving Licence';
    }
    
    // Check for PAN V2 structure (GridLines)
    if (data.report_name === 'PAN_DETAILS' ||
        data.report_name === 'PAN v2' ||  // Add support for actual report_name from DB
        data.data?.pan_details?.document_type === 'PAN' ||
        data.report_json?.data?.pan_details?.document_type === 'PAN' ||
        data.pan_details?.document_type === 'PAN' ||
        data.data?.pan_details?.raw_response?.data?.data?.pan_data ||
        data.pan_details?.raw_response?.data?.data?.pan_data ||
        (data.data?.pan_data && data.data?.code === '1000')) {
        return 'PAN v2';  // Return the key that exists in reportComponentMap
    }

    // Check for Voter ID V2 structure (GridLines)
    if (data.report_name === 'VOTER_ID_DETAILS' ||
        data.report_name === 'Voter ID v2' ||  // Add support for actual report_name from DB
        data.data?.voter_details?.document_type === 'VOTER' ||
        data.report_json?.data?.voter_details?.document_type === 'VOTER' ||
        data.voter_details?.document_type === 'VOTER' ||
        (data.data?.voter_data && data.data?.code === '1000')) {
        return 'Voter ID v2';  // Return the key that exists in reportComponentMap
    }
    
    // Check for Voter ID structure (original)
    if (data.response?.epicNo || data.report_json?.response?.epicNo || 
        data.data?.response?.epicNo || data.report_json?.data?.response?.epicNo) {
        return 'Voter ID';
    }
    
    // Check for Mobile Bureau Lookup structure
    if (data.response?.personal_information || data.report_json?.response?.personal_information ||
        data.data?.response?.personal_information || data.report_json?.data?.response?.personal_information ||
        (data.response?.score_detail && data.response?.document_data) ||
        (data.report_json?.response?.score_detail && data.report_json?.response?.document_data)) {
        // Additional checks to distinguish from regular Equifax
        if (data.status?.input?.mobile_no || data.status?.input?.mobile || 
            data.report_json?.status?.input?.mobile_no || data.report_json?.status?.input?.mobile ||
            data.report_name === 'MOBILE_BUREAU_LOOKUP' || 
            (data.response?.alternate_phone && data.response?.address)) {
            return 'Mobile Number Lookup';
        }
    }
    
    // Check for RC Details structure - based on RC details JSON structure
    // The report is stored with report_name: 'RC_DETAILS' and has structure: data.rc_details.raw_response.data.data.rc_data
    if (data.data?.rc_details?.raw_response?.data?.data?.rc_data ||
        data.rc_details?.raw_response?.data?.data?.rc_data ||
        data.data?.rc_details ||
        data.rc_details ||
        data.report_json?.data?.rc_details ||
        data.report_json?.rc_details ||
        // Check for direct rc_data structure
        data.rc_data ||
        data.data?.rc_data ||
        data.report_json?.rc_data ||
        data.report_json?.data?.rc_data ||
        // Check for response patterns
        data.response?.rc_data ||
        data.report_json?.response?.rc_data ||
        data.data?.response?.rc_data ||
        data.report_json?.data?.response?.rc_data ||
        // Check for any rc_details fields
        (data.data?.rc_details && (data.data.rc_details.rc_number !== undefined || data.data.rc_details.owner_name !== undefined || data.data.rc_details.raw_response)) ||
        (data.rc_details && (data.rc_details.rc_number !== undefined || data.rc_details.owner_name !== undefined || data.rc_details.raw_response))) {
        console.log('Detected as RC Details report');
        return 'RC Details';
    }
    
    // Check for CA Membership structure - based on CA membership JSON structure
    if ((data.response?.name && data.response?.AssociateYear) || 
        (data.report_json?.response?.name && data.report_json?.response?.AssociateYear) ||
        (data.data?.response?.name && data.data?.response?.AssociateYear) || 
        (data.report_json?.data?.response?.name && data.report_json?.data?.response?.AssociateYear) ||
        (data.status?.input?.membership_no) || 
        (data.report_json?.status?.input?.membership_no) ||
        (data.response?.AssociateYear) ||
        (data.report_json?.response?.AssociateYear) ||
        (data.data?.response?.AssociateYear) ||
        (data.report_json?.data?.response?.AssociateYear) ||
        (data.data?.membership_details?.AssociateYear) ||
        (data.report_json?.data?.membership_details?.AssociateYear) ||
        (data.membership_details?.AssociateYear) ||
        (data.report_json?.membership_details?.AssociateYear)) {
        // Additional checks to ensure it's CA Membership
        if (data.response?.AssociateYear || data.report_json?.response?.AssociateYear ||
            data.data?.response?.AssociateYear || data.report_json?.data?.response?.AssociateYear ||
            data.status?.input?.membership_no || data.report_json?.status?.input?.membership_no ||
            data.response?.Qualification || data.report_json?.response?.Qualification ||
            data.data?.response?.Qualification || data.report_json?.data?.response?.Qualification ||
            data.data?.membership_details?.AssociateYear || data.report_json?.data?.membership_details?.AssociateYear ||
            data.membership_details?.AssociateYear || data.report_json?.membership_details?.AssociateYear) {
            return 'CA Membership';
        }
    }
    
    // Check by report_name field
    if (data.report_name) {
        const reportName = data.report_name.toLowerCase();
        // Check for specific Experian report name from database
        if (reportName === 'experian_credit_report_boostmoney') {
            console.log('Detected EXPERIAN_CREDIT_REPORT_BOOSTMONEY from report_name');
            return 'EXPERIAN_CREDIT_REPORT_BOOSTMONEY';
        }
        // Check for RC Details first (priority for database stored name)
        if (reportName === 'rc_details' || reportName === 'rc details') {
            console.log('Detected RC Details from report_name:', data.report_name);
            return 'RC Details';
        }
        // Check for Mobile Bureau Lookup
        if (reportName === 'mobile_bureau_lookup' || reportName === 'mobile-bureau-lookup' ||
            reportName.includes('mobile_bureau') || reportName.includes('mobile-bureau') ||
            reportName.includes('mobile_lookup') || reportName.includes('mobile-lookup') ||
            reportName === 'mobile number lookup' || reportName === 'mobile bureau look up') {
            return 'Mobile Number Lookup';
        }
        // Check for Experian reports
        if (reportName.includes('experian')) {
            return 'Experian';
        }
        if (reportName.includes('equifax') || (reportName.includes('bureau') && !reportName.includes('mobile'))) {
            return 'Equifax';
        }
        if (reportName.includes('bank') || reportName.includes('statement')) {
            return 'Bank Statement Analysis';
        }
        if (reportName.includes('pan') || reportName.includes('PAN')) {
            return 'PAN Details';
        }
        if (reportName === 'uan_verification' || (reportName.includes('uan') && !reportName.includes('employment'))) {
            return 'UAN';
        }
        if (reportName.includes('uan') && reportName.includes('employment')) {
            return 'Employment History by UAN';
        }
        if (reportName.includes('employment') || (reportName.includes('mobile') && !reportName.includes('bureau') && !reportName.includes('lookup')) || reportName === 'employment_history') {
            return 'Employment History by Mobile';
        }
        // Check for Driving Licence V2 first (more specific)
        if (reportName === 'dl_details' || reportName === 'DL_DETAILS' || 
            reportName === 'driving_licence_v2' || reportName === 'driving-licence-v2' ||
            reportName.includes('dl_v2') || reportName.includes('licence_v2') || 
            reportName.includes('license_v2') || reportName.includes('dl v2')) {
            console.log('Detected Driving Licence V2 from report_name:', reportName);
            return 'Driving Licence V2';
        }
        // Then check for regular Driving Licence
        if (reportName.includes('driving') || reportName.includes('licence') || reportName.includes('license') || reportName.includes('dl')) {
            return 'Driving Licence';
        }
        if (reportName.includes('voter') || reportName.includes('epic')) {
            return 'Voter ID';
        }
        if (reportName.includes('ca') && reportName.includes('membership')) {
            return 'CA Membership';
        }
        if (reportName === 'ca_membership_verification' || reportName === 'CA_MEMBERSHIP_VERIFICATION') {
            return 'CA Membership';
        }
        if (reportName === 'rc_details' || reportName === 'RC_DETAILS' || reportName.includes('rc') || reportName.includes('registration certificate')) {
            return 'RC Details';
        }
    }
    
    return 'Unknown';
};

// Export a function to dynamically import new components
export const registerReportComponent = (reportType, componentConfig) => {
    reportComponentMap[reportType] = componentConfig;
};

// Export list of registered report types
export const getRegisteredReportTypes = () => {
    return Object.keys(reportComponentMap).filter(key => key !== 'default');
};